// extracted by mini-css-extract-plugin
export default {"icon":"li4VthGRn5zu2jACIyPL","hp":"FienMjb6pdZ0cYFBy8b6","shield":"Ll2wXzN0mC0V0d1A6CtE","root":"tIXhtzvcfQBRTbAXeSRZ"};